import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from '../../../components/layout/Navbar/Navbar';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import VagasDisponibilizadasHeader from '../../../components/Vagas-Disponibilizadas/VagasDisponibilizadasHeader';
import VagasContent from '../../../components/Vagas-Disponibilizadas/VagasContent';
import VagaDetalhe from '../../../components/Vagas-Disponibilizadas/VagaDetalhe';
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";

const NAVBAR_HEIGHT = 65;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  // background: #f9f9f9;
  background:rgb(255, 255, 255);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px;
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

const VagasDisponibilizadas = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [sortOrder, setSortOrder] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedVaga, setSelectedVaga] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const getTipoFilter = () => {
    const path = location.pathname;
    if (path === '/EstagioObrigatorio') return 'estagio-obrigatorio';
    if (path === '/Residencia') return 'residencia';
    if (path === '/AulaPratica') return 'aula-pratica';
    return null;
  };

  const getHeaderTitle = () => {
    const path = location.pathname;
    if (path === '/EstagioObrigatorio') return 'Estágio Obrigatório';
    if (path === '/Residencia') return 'Residência';
    if (path === '/AulaPratica') return 'Aula Prática';
    return 'Vagas Disponibilizadas';
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  const tipoFilter = getTipoFilter();
  const headerTitle = getHeaderTitle();

  return (
    <PageWrapper>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <VagasDisponibilizadasHeader
            user={user}
            onSortChange={setSortOrder}
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
            title={headerTitle}
          />
          {selectedVaga ? (
            <VagaDetalhe
              vaga={selectedVaga}
              user={user}
              onVoltar={() => setSelectedVaga(null)}
              onSolicitar={(vaga) => {
                setSelectedVaga(null);
                navigate("/solicitarVaga", { state: { vaga } });
              }}
            />
          ) : (
            <VagasContent
              user={user}
              sortOrder={sortOrder}
              searchTerm={searchTerm}
              tipoFilter={tipoFilter}
              onVerVaga={(vaga) => setSelectedVaga(vaga)}
              onEditarVaga={(vaga) => setSelectedVaga(vaga)}
            />
          )}
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default VagasDisponibilizadas;
